/**
 * pi-console-bridge — 브라우저 콘솔 로그를 pi가 읽을 수 있도록 전송
 *
 * 사용법:
 *   import { initPiConsoleBridge } from '@/utils/piConsoleBridge';
 *   initPiConsoleBridge({ serverUrl: 'http://localhost:9877' });
 *
 * 서버:
 *   node scripts/pi-console-server.js
 *
 * pi에서 조회:
 *   curl http://localhost:9877/logs
 */
import { serializeArgsForBridge } from '@/utils/debug/expandedConsoleLog';

const STORAGE_KEY = '__pi_console_logs__';
const MAX_LOGS = 500;
const FLUSH_INTERVAL = 2000;
const MAX_BRIDGE_MESSAGE_CHARS = 16000;

let logs = [];
let initialized = false;
let serverUrl = null;
let flushTimer = null;
let lastSentIdx = 0;

function persist() {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(logs.slice(-MAX_LOGS)));
  } catch (e) {
    /* quota exceeded */
  }
}

function flushToServer() {
  if (!serverUrl || lastSentIdx >= logs.length) return;
  const batch = logs.slice(lastSentIdx);
  lastSentIdx = logs.length;
  try {
    fetch(`${serverUrl}/log`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(batch),
      keepalive: true
    }).catch(() => {});
  } catch (e) {
    /* server 없으면 무시 */
  }
}

function scheduleFlush() {
  if (!serverUrl || flushTimer) return;
  flushTimer = setInterval(flushToServer, FLUSH_INTERVAL);
}

function addLog(level, args) {
  const entry = {
    t: Date.now(),
    l: level,
    m: serializeArgsForBridge(args).substring(0, MAX_BRIDGE_MESSAGE_CHARS)
  };
  logs.push(entry);
  if (logs.length > MAX_LOGS * 2) logs = logs.slice(-MAX_LOGS);
  persist();
}

export function initPiConsoleBridge(opts = {}) {
  if (initialized) return;
  initialized = true;
  serverUrl = opts.serverUrl || null;

  const _log = console.log.bind(console);
  const _warn = console.warn.bind(console);
  const _error = console.error.bind(console);

  console.log = function (...args) {
    _log(...args);
    addLog('log', args);
  };
  console.warn = function (...args) {
    _warn(...args);
    addLog('warn', args);
  };
  console.error = function (...args) {
    _error(...args);
    addLog('error', args);
  };

  window.__piGetLogs = since => {
    const all = logs;
    if (since) return all.filter(e => e.t >= since);
    return all;
  };
  window.__piClearLogs = () => {
    logs = [];
    lastSentIdx = 0;
  };
  window.__piLastLogTime = () => (logs.length ? logs[logs.length - 1].t : 0);

  scheduleFlush();
}
